export class ResetCustomerState {
  public static readonly type = '[Customer] reset state';
}

export class LoadCustomerBaseData {
  public static readonly type = '[Customer] load customer base data';
  constructor(public payload: { force: boolean }) {}
}

export class LoadContactData {
  public static readonly type = '[Customer] load contact data';
  constructor(public payload: { force: boolean }) {}
}

export class LoadCustomerAccountData {
  public static readonly type = '[Customer] load customer account data';
  constructor(public payload: { force: boolean }) {}
}
